module.exports = __webpack_public_path__ + "static/img/4.3914de5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ts/4.png
// module id = wejK
// module chunks = 1